import type { ChatService } from '../types';

import { createMockChatService } from './mock-service';

// ── Provider seam ────────────────────────────────────────────────────────────
//
// The whole module reaches the chat backend through `getChatService()`.
// It defaults to the local mock (deterministic for tests / no orchestrator
// dependency). The app swaps in the real orchestrator-backed service at
// startup via `initAiCio()`.

let activeService: ChatService = createMockChatService();

export function getChatService(): ChatService {
  return activeService;
}

export function setChatService(service: ChatService): void {
  activeService = service;
}
